import {lazy} from '@aboutyou/lazy-imports';

export const CountryDetection = lazy(() =>
  import('./CountryDetection.eager').then(mod => ({
    default: mod.CountryDetection,
  })),
);
